<template>
  <p>
    <span v-if="'status_id' in row || 'insured' in row" class="bet-label">
      <template v-if="row.status_id == '1'">
        <i class="tg-icon icon-guarantee"></i>
      </template>
      <template v-if="row.status_id == '2'">
        <i class="tg-icon icon-guarantee-vip"></i>
      </template>
      <template v-if="'insured' in row && row.insured == 1">
        <i class="tg-icon icon-insurance"></i>
      </template>
    </span>
    
    <span>{{row['betId']}}</span>
    <template v-if="row.trans_id">
      <br />
      <span class="text-info" style="word-break: break-word;">({{$t("column."+row['source_type'])}}) {{row['trans_id']}}</span>
    </template>
    <template v-if="row.note && (row.source_type != 'jdb_gaming' && row.source_type != 'pg_gaming' && row.source_type != 'pt_gaming' && row.source_type != 'mg_gaming')">
      <br />
      <span class="text-red">{{row['note']}}</span>
    </template>

    <template v-if="row.ticket_status_id && row.ticket_status_id > 0 && row.ticket_status_id <= 5">
      <br />
      <span class="text-red">{{$t("enum.bet_status["+row.ticket_status_id+"]")}}</span>
    </template>

    <!-- ob_casino的項目 注單狀態備註 -->
    <template  v-if="row.content_type == 8 && row.betFlag && row.betFlag != '' && row.betFlag != 0">
        <br />
        <span class="text-red" >({{ $t("enum.ob_casino.betFlag["+row.betFlag+"]") }})</span>
    </template>

    <!-- ag_casino的項目 注單狀態備註 -->
    <template  v-if="row.content_type == 9 && row.betFlag && (row.betFlag == 8 || row.betFlag == 9)">
        <br />
        <span class="text-red" >({{ $t("enum.ag_casino.betFlag["+row.betFlag+"]") }})</span>
    </template>

    <!-- sgwin_lottery的項目 注單狀態備註 -->
    <template  v-if="row.source_type == 'sgwin_lottery' && row.bet_status != 0">
        <br />
        <span class="text-red" >({{ $t("component.label.sgwin_lottery.["+row.bet_status+"]") }})</span>
    </template>

    <!-- ob_lottery的項目 注單狀態備註 -->
    <template v-if="row.source_type == 'ob_lottery' && row.cancel_type == 2">
       <br />
      <span
        v-if="row.cancel_desc"
        :class="{ 'text-red': true }"
      >
        {{ row.cancel_desc }}
      </span>
      <span
        v-else
        :class="{ 'text-red': true }"
      >
        {{ $t("component.label.ob_lottery.cancel_type[" + row.cancel_type + "]") }}
      </span>
    </template>
    <template v-else-if="row.source_type == 'ob_lottery' && row.cancel_type > 0">
      <span
        :class="{ 'text-red': true }"
      >
        {{ $t("component.label.ob_lottery.cancel_type[" + row.cancel_type + "]") }}
      </span>
    </template>

    <template  v-if="row.source_type == 'ob_lottery' && row.bet_status == 4">
        <br />
        <span class="text-red" >{{ $t("component.label.ob_lottery.cancel_type[5]") }}</span>
    </template>

    <!-- im_sport的項目 注單狀態備註 -->
    <template  v-if="row.source_type == 'im_sport' && row.isCancelled == 1">
        <br />
        <span class="text-red" >({{ $t("enum.bet_status[0]") }})</span>
    </template>

    <!-- ai_sport的項目 注單狀態備註 -->
    <template  v-if="row.source_type == 'ai_sport' && row.bet_status != -1">
        <br />
         <span class="text-red" >({{ $t("enum.ai_sport.bet_status["+row.bet_status+"]") }})</span>
    </template>

    <!-- allbet_casino的項目 注單狀態備註 -->
    <!-- 已取消 -->
    <template  v-if="row.source_type == 'allbet_casino' && row.bet_status == '101'">
        <br />
        <span class="text-red" >({{ $t("enum.bet_status[0]") }})</span>
    </template>

    <!-- 退款 -->
    <template  v-if="row.source_type == 'allbet_casino' && row.bet_status == '120'">
        <br />
        <span class="text-red" >({{ $t("enum.bet_status[4]") }})</span>
    </template>

    <!-- bd_casino的項目 注單狀態備註 -->
    <!-- 已取消 -->
    <template  v-if="row.source_type == 'bd_casino' && row.bet_status == '2'">
        <br />
        <span class="text-red" >({{ $t("enum.bet_status[0]") }})</span>
    </template>

    <!-- dg_casino的項目 注單狀態備註 -->
    <!-- 已取消 -->
    <template  v-if="row.source_type == 'dg_casino' && row.bet_status == '2'">
        <br />
        <span class="text-red" >({{ $t("enum.bet_status[0]") }})</span>
    </template>

    <!--mg_gaming的項目 注單狀態備註 -->
    <!-- 已取消 -->
    <template  v-if="row.source_type == 'mg_gaming' && row.bet_status == '2'">
        <br />
        <span class="text-red" >({{ $t("enum.bet_status[0]") }})</span>
    </template>

    <!--ia_esport的項目 注單狀態備註 -->
    <!-- 待确认、已取消 -->
    <template  v-if="row.source_type == 'ia_esport' && row.bet_status != '2'">
        <br />
        <span class="text-red" >({{ $t("enum.bet_status["+row.bet_status+"]") }})</span>
    </template>

    <template  v-if="row.source_type == 'fb_sport' && row.bet_status != '2'">
        <br />
        <span class="text-red" >({{ $t("enum.bet_status["+row.bet_status+"]") }})</span>
    </template>

    <template  v-if="row.source_type == 'evo_casino' && row.bet_status != '2'">
        <br />
        <span class="text-red" >({{ $t("enum.bet_status["+row.bet_status+"]") }})</span>
    </template>

    <template  v-if="row.source_type == 'sexy_casino' && row.bet_status != '2'">
        <br />
        <span class="text-red" >({{ $t("enum.bet_status["+row.bet_status+"]") }})</span>
    </template>
  </p>
</template>

<script>
export default {
  props: {
    row: Object,
  },
};
</script>